<template>
  <div class="laonlkbls text_center">
    <div class="flex between">
    	<sec-title
    	  Text="口碑律师"
		  :showmore ='false'
    	/>
		<span class="FontSize20 FontGray">合肥口碑律师在线咨询，口碑好，信誉高</span>
    </div>
    <div class="laonlkbls_cont between wrap">
      <qestlaywin
        class="kbls_item"
        v-for="(item, index) in list"
        :key="index"
		:item = 'item'
        :class="{ mb60: index < 3 }"
      />
    </div>
  </div>
</template>


<script>
import secTitle from "views/home/components/secTitle";
import qestlaywin from "views/findLawyers/components/qestlaywin2";
export default {
  components: {
    secTitle,
    qestlaywin,
  },
  data: () => ({
	  list:[]
  }),
  created() {
  	this.$http.home.lawyerads({
  		ad_id:6,
  		limit:5,
  		order:'hot',
  	}).then( res => {
  		this.list = res.data.data
  	})
  },
  methods: {},
};
</script>

<style lang="scss" scope>
.laonlkbls {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .laonlkbls_cont {
    margin-bottom: 40px;
    .kbls_item {
      width: 358px;
      height: 360px;
    }
    .mb60 {
      margin-bottom: 60px;
    }
  }
}
</style>